import { InfiniteData } from 'react-query';
import * as rudderanalytics from 'rudder-sdk-js';

import { ProductsListData } from 'app/api/products/types';
import { formatProductAnalyticsData } from './formatProductAnalyticsData';

export const getSearchPerformedEventResults = (data?: InfiniteData<ProductsListData>): rudderanalytics.apiObject[] => {
  const results = (data?.pages?.flatMap((item) => item?.results ?? []) ?? []).map((product) =>
    formatProductAnalyticsData({ product, isRank: true }),
  ) as unknown as rudderanalytics.apiObject[];

  return results;
};
